import Axios from 'axios';

// Axios.defaults.baseURL = 'https://flight.musafirbazar.com/api/';
Axios.defaults.baseURL = 'https://newinv.musafirbazar.com/api/';

export const axiosInstance = Axios.create({});
